import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const QuestionCircle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.20353 7.28235C7.7874 7.58855 7.33484 7.92157 7.33484 8.64592C7.33484 8.83085 7.42604 9.06201 7.42604 9.06201H8.65734C8.65734 8.51386 8.99873 8.21568 9.37016 7.89126C9.81325 7.50425 10.2991 7.07991 10.2991 6.14935C10.2991 5.17847 9.4326 4.30005 8.1101 4.30005C6.28595 4.30005 5.82992 5.87196 5.82992 5.87196L6.97001 6.38052C6.97001 6.38052 7.19803 5.6408 8.06449 5.6408C8.56613 5.6408 8.88536 5.96442 8.88536 6.33429C8.88536 6.78064 8.55764 7.02179 8.20353 7.28235Z"
      fill="currentColor"
    />
    <path d="M7.29907 11.8V10.3H8.79907V11.8H7.29907Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default QuestionCircle;
